// extracted by mini-css-extract-plugin
export default {"terms_modal_body":"TermsCondition_terms_modal_body__ySJfW"};